import React, { useState } from 'react';
import { Box, useMediaQuery, ThemeProvider } from '@mui/material';
import { useTheme } from '@mui/material/styles';
import theme from './theme';

// Types and Hooks
import { ViewType } from './types';
import { useCart } from './hooks/useCart';

// Layout Components
import AppHeader from './components/layout/AppHeader';
import BottomNavigation from './components/layout/BottomNavigation';

// View Components
import MenuView from './components/MenuView';
import CartDialog from './components/CartDialog';

// Styles
import './App.css';

function App() {
  // State
  const [currentView, setCurrentView] = useState<ViewType>('menu');
  const [cartOpen, setCartOpen] = useState(false);
  const [selectedCategory, setSelectedCategory] = useState('bowls');

  // Hooks
  const muiTheme = useTheme();
  const isMdUp = useMediaQuery(muiTheme.breakpoints.up('md'));
  const { cartItems, addToCart, updateQuantity, removeItem, cartItemCount } = useCart();

  // Handlers
  const handleViewChange = (event: React.SyntheticEvent, newValue: ViewType) => {
    setCurrentView(newValue);
  };

  const handleCategorySelect = (categoryId: string) => {
    setSelectedCategory(categoryId);
  };

  const handleCheckout = (tableNumber: string) => {
    console.log('Proceeding to checkout with items:', cartItems, 'Table number:', tableNumber);
    setCartOpen(false);
  };

  const handleMobileNavChange = (_: React.SyntheticEvent, value: ViewType | 'cart') => {
    if (value === 'cart') {
      setCartOpen(true);
      return;
    }
    setCurrentView(value as ViewType);
  };

  // Main content (customer-facing portal only shows the menu)
  const renderMainContent = () => {
    return <MenuView onAddToCart={addToCart} />;
  };

  return (
    <ThemeProvider theme={theme}>
      <Box sx={{ display: 'flex' }}>
      {/* App Header */}
      <AppHeader
        cartItemCount={cartItemCount}
        onCartOpen={() => setCartOpen(true)}
      />


      {/* Main Content */}
      <Box 
        component="main" 
        sx={{ 
          flexGrow: 1, 
          p: { xs: 0, md: 3 }, 
          mt: { xs: 7, md: 8 }, 
          pb: { xs: 9, md: 0 },
          minHeight: '100vh'
        }}
      >
        {renderMainContent()}
      </Box>

      {/* Cart Dialog */}
      <CartDialog
        open={cartOpen}
        onClose={() => setCartOpen(false)}
        cartItems={cartItems}
        onUpdateQuantity={updateQuantity}
        onRemoveItem={removeItem}
        onCheckout={handleCheckout}
      />

      {/* Mobile Bottom Navigation */}
      {!isMdUp && (
        <BottomNavigation
          currentView={currentView}
          cartItemCount={cartItemCount}
          onNavigationChange={handleMobileNavChange}
        />
      )}
    </Box>
    </ThemeProvider>
  );
}

export default App;